/* 竹村商会 商品カタログ（tkc）— 依存ライブラリなし。グローバル変数を作らない。
   データ：#tkc-data（Shopifyの商品情報と tkm Metafield から Liquid で出力した JSON）
   状態：URL の # の後ろ（q・use・brand・genre・volt・sock・sort・cmp） */
(function () {
  'use strict';
  var root = document.getElementById('tkc');
  var dataEl = document.getElementById('tkc-data');
  if (!root || !dataEl) return;
  var DICT = {"SOCKET_SYN":{"T10":["T10","ウェッジ","ウエッジ","ウェッジ球","W5W","T10ウェッジ"],"BA15s":["BA15s","S25シングル","S25","シングル球","G18","平行ピン"],"S25シングル":["S25シングル","BA15s","S25","シングル球","G18"],"BAY15d":["BAY15d","S25ダブル","S25","ダブル球","段違いピン"],"S25ダブル":["S25ダブル","BAY15d","S25","ダブル球","段違いピン"],"BA15d":["BA15d","S25ダブル平行ピン","S25","ダブル球","平行ピン"],"BA9s":["BA9s","G14","角マーカー球"],"S25":["S25","ピン角150度","ピン角180度","S25シングル"],"T20シングル":["T20シングル","T20","W21W"],"T20ダブル":["T20ダブル","T20","W21/5W","7443"],"T20ピンチ部違い":["T20ピンチ部違い","T20"],"T16":["T16","T15","W16W"],"H1":["H1"],"H3":["H3"],"H4":["H4","Hi/Lo"],"H7":["H7"],"H8":["H8"],"H11":["H11"],"PSX26W":["PSX26W"],"PH7":["PH7","P15d-25-1"],"P15d-25-1":["P15d-25-1","PH7"],"E12":["E12","口金E12"],"T10×31mm":["T10×31mm","T10x31","31mm","マクラ球","フェストン","フェストン球"],"T10×28mm":["T10×28mm","T10x28","28mm","マクラ球","フェストン"],"T10×36mm":["T10×36mm","T10x36","36mm","マクラ球","フェストン"],"T10×39mm":["T10×39mm","T10x39","39mm","マクラ球","フェストン"],"T10×41mm":["T10×41mm","T10x41","41mm","マクラ球","フェストン"],"T8×28mm":["T8×28mm","T8x28","28mm","マクラ球","フェストン"]},"GENRE_SYN":{"LEDテープ":["LEDテープ","テープLED","LEDテープライト","テープライト","ledテープ","LEDライン","間接照明"],"LEDテープ用パーツ":["LEDテープ用パーツ","パーツ","部品","LEDテープ部品"],"マーカーランプ":["マーカーランプ","マーカー","サイドマーカー","車高灯"],"マーカー用バルブ":["マーカー用バルブ","マーカー球","マーカーバルブ"],"ヘッドライト・フォグ":[],"ヘッドライト":["ヘッドライト","ヘッドランプ","Hi/Lo"],"フォグランプ":["フォグ","フォグランプ","フォグライト"],"ウインカー":["ウインカー","ウィンカー","方向指示器","ターンランプ"],"ブレーキ・テール":["ブレーキ","ブレーキランプ","テール","テールランプ","尾灯","制動灯","ストップランプ"],"ウインカー・ブレーキ・テール":[],"ポジション":["ポジション","ポジションランプ","ポジション球","車幅灯","スモール","スモールランプ"],"ポジション・ルームランプ":[],"ルームランプ・シャンデリア":["ルームランプ","室内灯","車内灯","シャンデリア"],"バックランプ":["バックランプ","バック球","後退灯","バックライト","リバースランプ"],"ステッカー":["ステッカー","シール"],"ホーン":["ホーン","ヤンキーホーン","エアーホーン"]},"USE_SYN":{"Truck":["トラック","トラック用","デコトラ","大型車"],"Car / Bike":["乗用車","車","カー","バイク","単車","オートバイ"],"Ship":["船","船舶","ボート","漁船","船用"],"Home":["住宅","屋外","家"]},"USE_LABEL":{"Truck":"トラック","Car / Bike":"乗用車・バイク","Ship":"船舶","Home":"住宅・屋外"},"COLOR_SYN":{"ホワイト":["ホワイト","白"],"レッド":["レッド","赤"],"ブルー":["ブルー","青"],"グリーン":["グリーン","緑"],"ピンク":["ピンク"],"アンバー":["アンバー","オレンジ"],"濃いアンバー":["濃いアンバー","アンバー"],"イエロー":["イエロー","黄色","黄"],"アイスブルー":["アイスブルー","水色"],"電球色":["電球色"],"パープル":["パープル","紫"],"ライムグリーン":["ライムグリーン","黄緑"],"レインボー":["レインボー"],"オレンジ":["オレンジ"]},"FUNC_SYN":[["フォグ",["フォグ","フォグランプ","フォグライト"]],["ヘッドライト",["ヘッドライト","ヘッドランプ"]],["ハイビーム",["ハイビーム","ヘッドライト"]],["ウインカー",["ウインカー","ウィンカー","方向指示器"]],["ウィンカー",["ウインカー","ウィンカー"]],["ブレーキ",["ブレーキ","ブレーキランプ"]],["テール",["テール","テールランプ"]],["ポジション",["ポジション","ポジションランプ","車幅灯","スモール"]],["ルームランプ",["ルームランプ","室内灯"]],["バックランプ",["バックランプ","バック球","後退灯"]],["ストロボ",["ストロボ","点滅","フラッシュ"]],["ホタル",["ホタル点滅","ホタル","点滅"]],["ゆっくり点滅",["ゆっくり点滅","点滅"]],["点滅",["点滅"]],["シンクロ",["シンクロ"]],["クルクル",["クルクル","回転"]],["グラデーション",["グラデーション","レインボー"]],["2色",["2色","2色発光","2色切替"]],["抵抗内蔵",["抵抗内蔵","ハイフラ防止","ハイフラ"]],["ハイフラ",["ハイフラ防止","ハイフラ"]],["非防水",["非防水"]],["防水",["防水"]],["COB",["COB"]],["ダウンライト",["ダウンライト","路肩灯"]],["ガラスレンズ",["ガラスレンズ"]],["ハイエース",["ハイエース"]],["スーパーグレート",["スーパーグレート","17スーパーグレート"]],["アンドン",["アンドン","行灯"]],["保護キャップ",["保護キャップ","エンドキャップ","キャップ"]],["コネクタ",["コネクタ","コネクター"]],["配線",["配線","延長配線"]],["ルーセント",["ルミナスルーセント","ルーセント"]],["ルーシッド",["ルーシッド"]],["シャンデリア",["シャンデリア"]],["マクラ球",["マクラ球","フェストン"]],["バスマーカー",["バスマーカー"]],["角マーカー",["角マーカー"]],["点灯点滅",["点灯点滅切替","点滅"]],["点灯切替",["点灯切替"]],["3mm幅",["3mm幅","極細"]],["ミニマーカー",["ミニマーカー"]]],"BANNED":["車検対応","車検","最強","爆光","No.1","ナンバーワン","純正同等","世界初","完全防水","JIS"]};
  var RAW;
  try { RAW = JSON.parse(dataEl.textContent).items || []; } catch (e) { RAW = []; }

  var USES = [
    { id: 'Truck', label: 'トラック' },
    { id: 'Car / Bike', label: '乗用車・バイク' },
    { id: 'Ship', label: '船舶' }
  ];
  var USE_KEY = { 'Truck': 'truck', 'Car / Bike': 'car', 'Ship': 'ship' };
  var KEY_USE = { truck: 'Truck', car: 'Car / Bike', ship: 'Ship' };
  var BRAND_ORDER = ['Takenous', 'Takenous_Plus', 'Takeship'];
  var VOLTS = ['6V', '12V', '24V'];
  var CMP_MAX = 3;
  var QUICK = ['24V', '12V', 'T10', 'BA15s', 'LEDテープ', 'マーカー', 'バックランプ', 'フォグ'];
  // 同じ口金の別名を1つの選択肢にまとめる
  var SOCKET_GROUP = {
    'BA15s': 'BA15s（S25シングル）', 'S25シングル': 'BA15s（S25シングル）',
    'BAY15d': 'BAY15d（S25ダブル）', 'S25ダブル': 'BAY15d（S25ダブル）',
    'PH7': 'PH7（P15d-25-1）', 'P15d-25-1': 'PH7（P15d-25-1）',
    'S25': 'S25（ピン角150度／180度）', 'BA15d': 'BA15d（S25ダブル平行ピン）'
  };
  var SOCKET_SHORT = { 'BA15s（S25シングル）': 'BA15s', 'BAY15d（S25ダブル）': 'BAY15d', 'PH7（P15d-25-1）': 'PH7', 'S25（ピン角150度／180度）': 'S25', 'BA15d（S25ダブル平行ピン）': 'BA15d' };

  function norm(s) { return String(s || '').normalize('NFKC').toLowerCase().replace(/[×✕]/g, 'x').replace(/\s+/g, ' ').trim(); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function yen(n) { return Number(n || 0).toLocaleString('ja-JP'); }
  function $(sel) { return root.querySelector(sel); }
  function $$(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function uniq(a) { var o = []; a.forEach(function (x) { if (x && o.indexOf(x) < 0) o.push(x); }); return o; }
  function stripCode(t) { return String(t || '').replace(/\s*[（(][^()（）]*take[^()（）]*[)）]\s*$/i, '').replace(/\s{2,}/g, ' ').trim(); }
  function sockGroup(s) { return SOCKET_GROUP[s] || s; }
  function sockShort(g) { return SOCKET_SHORT[g] || g; }
  function specLines(spec) {
    return String(spec || '').split('\n').map(function (l) { return l.trim(); }).filter(function (l) { return l.indexOf('：') > 0; })
      .map(function (l) { var i = l.indexOf('：'); return [l.slice(0, i).trim(), l.slice(i + 1).trim()]; });
  }

  /* ---------- 商品データの組み立て（Shopifyの値から計算。データの二重管理をしない） ---------- */
  var modelCount = {};
  RAW.forEach(function (r) { if (r.model) modelCount[r.model] = (modelCount[r.model] || 0) + 1; });
  var DATA = RAW.map(function (r) {
    var it = { h: r.h, url: r.url, img: r.img, p0: r.p0, p1: r.p1, avail: r.avail, amazon: r.amazon };
    it.title = r.title; it.name = stripCode(r.title);
    it.brands = r.brands || []; it.genre = r.genre || ''; it.use = r.use || []; it.pol = r.pol || ''; it.warranty = r.warranty || '';
    it.points = (r.points || []).filter(Boolean); it.caution = r.caution || '';
    it.spec = specLines(r.spec);
    var specMap = {}; it.spec.forEach(function (kv) { specMap[kv[0]] = kv[1]; });
    var voltOpt = (r.opts || []).filter(function (o) { return /電圧/.test(o.n); })[0];
    var volts = (r.volt || []).slice();
    it.vmode = volts.length > 1 ? 'both' : (volts.length ? 'single' : 'none');
    if (!volts.length) {
      var src = (voltOpt && voltOpt.v.length > 1) ? voltOpt.v.join(' ') : (specMap['対応電圧'] || '');
      VOLTS.forEach(function (v) { if (norm(src).indexOf(norm(v)) >= 0) volts.push(v); });
      if (volts.length) it.vmode = (voltOpt && voltOpt.v.length > 1) ? 'select' : 'mixed';
      else if (/パーツ/.test(it.genre)) it.vmode = 'part';
    }
    it.volts = volts;
    if (it.vmode === 'both') it.vtext = volts.join('・') + '兼用';
    else if (it.vmode === 'single') it.vtext = volts[0] + '専用';
    else if (it.vmode === 'select') it.vtext = '12V用・24V用から選ぶ';
    else if (it.vmode === 'mixed') it.vtext = (specMap['対応電圧'] || '').replace(/（[^）]*選択[^）]*）/, '');
    else if (it.vmode === 'part') it.vtext = 'LEDテープ用の部品';
    else it.vtext = '';
    it.vshort = it.vmode === 'both' ? volts.map(function (v) { return v.replace('V', ''); }).join('・') + 'V'
      : it.vmode === 'single' ? volts[0] : it.vmode === 'select' ? '12V／24V' : it.vmode === 'mixed' ? volts.map(function (v) { return v.replace('V', ''); }).join('・') + 'V' : '';
    it.socks = r.sock || [];
    it.sockGroups = uniq(it.socks.map(sockGroup));
    it.model = r.model || '';
    it.modelDisp = it.model && modelCount[it.model] > 1 && volts.length === 1 ? it.model + '（' + volts[0] + '）' : it.model;
    var colorOpt = (r.opts || []).filter(function (o) { return /カラー|色/.test(o.n) && !/点滅|パターン/.test(o.n); })[0];
    it.colors = colorOpt ? colorOpt.v : [];
    it.specKey = it.spec.filter(function (kv) { return /^(発光色|消費電力|サイズ|長さ|全長|セット内容|セット個数|防水構造|点灯パターン|ピン角|LED|互換規格)/.test(kv[0]); }).slice(0, 6);
    // 検索語（辞書から機械的に作る。誤解を招く語は入れない）
    var terms = [it.name, it.title, it.model, it.modelDisp];
    it.brands.forEach(function (b) { terms.push(b); });
    terms = terms.concat(DICT.GENRE_SYN[it.genre] || [it.genre]);
    it.use.forEach(function (u) { terms.push(DICT.USE_LABEL[u] || u); terms = terms.concat(DICT.USE_SYN[u] || []); });
    it.volts.forEach(function (v) { terms.push(v, 'DC' + v); });
    if (it.vmode === 'both') terms.push('兼用', '12V24V兼用');
    it.socks.forEach(function (s) { terms = terms.concat(DICT.SOCKET_SYN[s] || [s]); });
    it.colors.forEach(function (c) { terms = terms.concat(DICT.COLOR_SYN[c] || [c]); });
    var fx = it.title + ' ' + it.spec.map(function (kv) { return kv[1]; }).join(' ') + ' ' + it.points.join(' ');
    DICT.FUNC_SYN.forEach(function (f) { if (f[0] === '防水' ? /(^|[^非])防水/.test(fx) : fx.indexOf(f[0]) >= 0) terms = terms.concat(f[1]); });
    if (specMap['防水構造'] && !/非防水/.test(specMap['防水構造'])) terms.push('防水');
    terms = terms.filter(function (t) { return t && !DICT.BANNED.some(function (b) { return String(t).indexOf(b) >= 0; }); });
    it.terms = uniq(terms.map(norm));
    it.hay = ' ' + it.terms.join(' | ') + ' ';
    it.voltsN = it.volts.map(norm);
    return it;
  });
  var BYH = {}, URLH = {}; DATA.forEach(function (it) { BYH[it.h] = it; URLH[it.url] = it.h; });
  var TOTAL = DATA.length;

  /* ---------- 状態と URL（# の後ろ） ---------- */
  var state = { q: '', use: '', brand: [], genre: [], volt: [], sock: [], sort: 'rec', cmp: [] };
  function readState() {
    var raw = location.hash.replace(/^#/, '');
    if (!raw && location.search) raw = location.search.replace(/^\?/, ''); // 古い ? 形式も読む
    var p = new URLSearchParams(raw);
    state.q = p.get('q') || '';
    state.use = KEY_USE[p.get('use')] || (USES.some(function (u) { return u.id === p.get('use'); }) ? p.get('use') : '');
    ['brand', 'genre', 'volt', 'sock'].forEach(function (k) { state[k] = p.get(k) ? p.get(k).split(',').filter(Boolean) : []; });
    state.sock = uniq(state.sock.map(sockGroup));   // 商品ページからのリンク（#sock=BA15s など口金そのままの名前）も、絞り込みの選択肢の名前にそろえる
    state.sort = /^(rec|price-asc|price-desc|model)$/.test(p.get('sort') || '') ? p.get('sort') : 'rec';
    state.cmp = (p.get('cmp') ? p.get('cmp').split(',') : []).filter(function (h) { return BYH[h]; }).slice(0, CMP_MAX);
    var q = $('.tkc-search__input'); if (q) q.value = state.q;
  }
  function writeState() {
    var p = new URLSearchParams();
    if (state.q) p.set('q', state.q);
    if (state.use) p.set('use', USE_KEY[state.use] || state.use);
    ['brand', 'genre', 'volt', 'sock'].forEach(function (k) { if (state[k].length) p.set(k, state[k].join(',')); });
    if (state.sort !== 'rec') p.set('sort', state.sort);
    if (state.cmp.length) p.set('cmp', state.cmp.join(','));
    var qs = p.toString();
    try { history.replaceState(null, '', location.pathname + (qs ? '#' + qs : '')); } catch (e) { /* 表示に影響しない */ }
    root.setAttribute('data-state', qs);
  }

  /* ---------- 検索と絞り込み ---------- */
  var SOLO_SOCK = {};
  DATA.forEach(function (it) { it.socks.forEach(function (s) { var n = norm(s); if (/^[a-z]{1,3}\d{1,3}[a-z]?$/.test(n)) SOLO_SOCK[n] = 1; }); });
  function tokenMatch(it, tok) {
    if (/^\d{1,3}v$/.test(tok)) return it.voltsN.indexOf(tok) >= 0;               // 24v などは電圧に完全一致
    if (/^[a-z]{1,3}\d{1,3}[a-z]?$/.test(tok)) {                                     // t10・h11・ba15s などは語の区切りで一致
      // 単独の口金がある語（t10 など）は T10×31mm を含めない。単独の口金がない語（t8 など）は T8×28mm に一致させる
      var re = new RegExp('(^|[^a-z0-9])' + tok + (SOLO_SOCK[tok] ? '(?![0-9a-z]|x\\d)' : '(?=x\\d|[^0-9a-z]|$)'));
      return re.test(it.hay);
    }
    if (tok === '防水') return /(^|[^非])防水/.test(it.hay);                     // 「防水」で非防水を出さない
    return it.hay.indexOf(tok) >= 0;
  }
  function tokens(q) { return norm(q).replace(/takenous[\s_]*plus/g, 'takenous_plus').split(' ').filter(Boolean); }
  function match(it, skip, st) {
    st = st || state;
    if (skip !== 'use' && st.use && it.use.indexOf(st.use) < 0) return false;
    if (skip !== 'brand' && st.brand.length && !st.brand.some(function (b) { return it.brands.indexOf(b) >= 0; })) return false;
    if (skip !== 'genre' && st.genre.length && st.genre.indexOf(it.genre) < 0) return false;
    if (skip !== 'volt' && st.volt.length && !st.volt.some(function (v) { return it.volts.indexOf(v) >= 0; })) return false;
    if (skip !== 'sock' && st.sock.length && !st.sock.some(function (s) { return it.sockGroups.indexOf(s) >= 0; })) return false;
    if (skip !== 'q' && st.q) { var t = tokens(st.q); for (var i = 0; i < t.length; i++) if (!tokenMatch(it, t[i])) return false; }
    return true;
  }
  function results(st) { return DATA.filter(function (it) { return match(it, null, st); }); }
  function countBy(key) {
    var c = {};
    DATA.forEach(function (it) {
      if (!match(it, key)) return;
      var vals = key === 'brand' ? it.brands : key === 'genre' ? [it.genre] : key === 'volt' ? it.volts : key === 'sock' ? it.sockGroups : it.use;
      vals.forEach(function (v) { c[v] = (c[v] || 0) + 1; });
    });
    return c;
  }
  function sorted(list) {
    var l = list.slice();
    var bo = function (it) { var i = BRAND_ORDER.indexOf(it.brands[0]); return i < 0 ? 9 : i; };
    var mc = function (a, b) { return (a.model || a.h).localeCompare(b.model || b.h, 'ja', { numeric: true }); };
    if (state.sort === 'price-asc') l.sort(function (a, b) { return a.p0 - b.p0 || mc(a, b); });
    else if (state.sort === 'price-desc') l.sort(function (a, b) { return b.p0 - a.p0 || mc(a, b); });
    else if (state.sort === 'model') l.sort(mc);
    else l.sort(function (a, b) { return (b.avail - a.avail) || (bo(a) - bo(b)) || a.genre.localeCompare(b.genre, 'ja') || mc(a, b); });
    return l;
  }

  /* ---------- 計測（GTM の dataLayer があるときだけ送る。無ければ何もしない。個人情報は送らない） ---------- */
  function track(ev, p) {
    try { if (window.dataLayer && typeof window.dataLayer.push === 'function') { var o = { event: ev, tkc_version: root.getAttribute('data-version') || '' }; for (var k in p) o['tkc_' + k] = p[k]; window.dataLayer.push(o); } } catch (e) { }
  }
  function filterSig() { return ['q', 'use', 'brand', 'genre', 'volt', 'sock'].map(function (k) { var v = state[k]; return Array.isArray(v) ? v.join('|') : v; }).join('/'); }

  /* ---------- 表示 ---------- */
  var LABEL = { brand: 'ブランド', genre: 'ジャンル', volt: '電圧', sock: '口金', use: '用途', q: '検索' };
  function useLabel(u) { var x = USES.filter(function (y) { return y.id === u; })[0]; return x ? x.label : (DICT.USE_LABEL[u] || u); }
  function chip(kind, value, label, extraCls) {
    return '<button type="button" class="tkc-chip' + (extraCls ? ' ' + extraCls : '') + '" data-refine="' + kind + '" data-v="' + esc(value) + '" aria-label="' + esc(label) + 'で絞り込む">' + esc(label) + '</button>';
  }
  function imgTag(it, w) {
    if (!it.img) return '';
    var base = it.img.replace(/([?&])width=\d+(&|$)/, '$1').replace(/[?&]$/, '');   // Liquid が付けた width を外してから付け直す
    var u = base + (base.indexOf('?') > 0 ? '&' : '?');
    return '<img src="' + esc(u + 'width=' + w) + '" srcset="' + esc(u + 'width=240') + ' 240w, ' + esc(u + 'width=360') + ' 360w, ' + esc(u + 'width=480') + ' 480w" sizes="(min-width: 1024px) 240px, (min-width: 600px) 30vw, 46vw" width="480" height="480" alt="" loading="lazy" decoding="async" onerror="this.remove()">';
  }
  function cardHTML(it) {
    var inCmp = state.cmp.indexOf(it.h) >= 0;
    var specChips = '';
    if (it.vmode === 'part') specChips += '<span class="tkc-chip tkc-chip--static">' + esc(it.vtext) + '</span>';
    else it.volts.forEach(function (v) { specChips += chip('volt', v, v, 'tkc-chip--volt'); });
    it.sockGroups.slice(0, 2).forEach(function (g) { specChips += chip('sock', g, sockShort(g)); });
    if (it.sockGroups.length > 2) specChips += '<span class="tkc-chip tkc-chip--static">ほか' + (it.sockGroups.length - 2) + '</span>';
    var useChips = it.use.map(function (u) { return chip('use', u, useLabel(u), 'tkc-chip--use'); }).join('');
    var price = yen(it.p0) + '<small>円' + (it.p1 > it.p0 ? '〜' : '') + '</small>';
    return '<li class="tkc-card' + (inCmp ? ' is-cmp' : '') + '" data-h="' + esc(it.h) + '">' +
      '<a class="tkc-card__img" href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true"><span class="tkc-card__ph">' + esc(it.modelDisp || '') + '</span>' + imgTag(it, 360) +
        (it.avail ? '' : '<span class="tkc-card__flag">在庫なし</span>') + '</a>' +
      '<button type="button" class="tkc-cmpbtn" data-cmp="' + esc(it.h) + '" aria-pressed="' + inCmp + '" aria-label="' + esc(it.modelDisp || it.name) + 'を比較' + (inCmp ? 'から外す' : 'に追加') + '"><span aria-hidden="true">' + (inCmp ? '✓' : '＋') + '</span>' + (inCmp ? '比較中' : '比較') + '</button>' +
      '<div class="tkc-card__body">' +
        '<p class="tkc-card__brand">' + esc(it.brands.join(' / ')) + '</p>' +
        '<h2 class="tkc-card__name"><a href="' + esc(it.url) + '">' + esc(it.name) + '</a></h2>' +
        (it.modelDisp ? '<p class="tkc-card__model">' + esc(it.modelDisp) + '</p>' : '') +
        '<div class="tkc-card__spec">' + specChips + '</div>' +
        (it.points[0] ? '<p class="tkc-card__point">' + esc(it.points[0]) + '</p>' : '') +
        '<div class="tkc-card__use">' + useChips + '</div>' +
        '<div class="tkc-card__foot"><span class="tkc-card__price">' + price + '</span><a class="tkc-card__go" href="' + esc(it.url) + '">商品を見る</a></div>' +
      '</div></li>';
  }
  /* カードは商品ごとに1回だけ作り、絞り込み・並べ替えでは並べ直すだけ（画像を読み直さない・比較ボタンのフォーカスが外れない） */
  var cardNode = {};
  function cmpBtnState(n, it) {
    var inCmp = state.cmp.indexOf(it.h) >= 0;
    n.classList.toggle('is-cmp', inCmp);
    var b = n.querySelector('.tkc-cmpbtn');
    if (b.getAttribute('aria-pressed') !== String(inCmp)) {
      b.setAttribute('aria-pressed', String(inCmp));
      b.setAttribute('aria-label', (it.modelDisp || it.name) + 'を比較' + (inCmp ? 'から外す' : 'に追加'));
      b.innerHTML = '<span aria-hidden="true">' + (inCmp ? '✓' : '＋') + '</span>' + (inCmp ? '比較中' : '比較');
    }
    return n;
  }
  function cardEl(it) {
    var n = cardNode[it.h];
    if (!n) { var tmp = document.createElement('ul'); tmp.innerHTML = cardHTML(it); n = cardNode[it.h] = tmp.firstChild; }
    return cmpBtnState(n, it);
  }
  function renderGrid(res) {
    var grid = $('.tkc-grid--main');
    var nodes = res.map(cardEl);
    var cur = grid.children, same = cur.length === nodes.length;
    for (var i = 0; same && i < nodes.length; i++) if (cur[i] !== nodes[i]) same = false;
    if (same) return;
    var act = document.activeElement, keep = act && grid.contains(act) ? act : null;
    var frag = document.createDocumentFragment();
    nodes.forEach(function (n) { frag.appendChild(n); });
    while (grid.firstChild) grid.removeChild(grid.firstChild);
    grid.appendChild(frag);
    if (keep && grid.contains(keep) && keep.focus) keep.focus({ preventScroll: true });
  }
  function facetHTML(key, title, opts, open, hint) {
    var html = '<details class="tkc-facet" data-facet="' + key + '"' + (open ? ' open' : '') + '><summary class="tkc-facet__sum"><span>' + esc(title) + '</span><span class="tkc-facet__n" hidden></span></summary><ul class="tkc-facet__list">';
    html += opts.map(function (o) {
      return '<li><label class="tkc-opt"><input type="checkbox" data-facet-input="' + key + '" value="' + esc(o) + '"><span class="tkc-opt__l">' + esc(o) + '</span><span class="tkc-opt__c"></span></label></li>';
    }).join('');
    html += '</ul>' + (hint ? '<p class="tkc-facet__hint">' + esc(hint) + '</p>' : '') + '</details>';
    return html;
  }
  var facetOpen = {};
  var isWide = window.matchMedia('(min-width: 1024px)').matches;
  var FACET_KEYS = ['volt', 'sock', 'genre', 'brand'];
  var facetEls = null;
  /* 絞り込みの選択肢は商品データから1回だけ作り、その後は件数・選択状態だけを書き換える（クリック中のチェックボックスを作り直さないので、速く、キーボードのフォーカスも外れない） */
  function buildFacets() {
    var wide = isWide;
    var brands = BRAND_ORDER.filter(function (b) { return DATA.some(function (it) { return it.brands.indexOf(b) >= 0; }); });
    var genres = uniq(DATA.map(function (it) { return it.genre; })).sort(function (a, b) { return a.localeCompare(b, 'ja'); });
    var volts = VOLTS.filter(function (v) { return DATA.some(function (it) { return it.volts.indexOf(v) >= 0; }); });
    var allS = {}; DATA.forEach(function (it) { it.sockGroups.forEach(function (g) { allS[g] = (allS[g] || 0) + 1; }); });
    var socks = Object.keys(allS).sort(function (a, b) { return allS[b] - allS[a] || a.localeCompare(b, 'ja'); });
    function isOpen(k, def) { return facetOpen.hasOwnProperty(k) ? facetOpen[k] : (wide || def || state[k].length > 0); }
    var box = $('.tkc-facets');
    box.innerHTML =
      facetHTML('volt', '電圧', volts, isOpen('volt', true), '12V・24V兼用の商品と、12V用・24V用を選ぶ商品は、どちらを選んでも表示されます。') +
      facetHTML('sock', '口金・規格', socks, isOpen('sock', false)) +
      facetHTML('genre', 'ジャンル', genres, isOpen('genre', false)) +
      facetHTML('brand', 'ブランド', brands, isOpen('brand', false));
    facetEls = {};
    FACET_KEYS.forEach(function (k) {
      var det = box.querySelector('.tkc-facet[data-facet="' + k + '"]');
      facetEls[k] = { det: det, n: det.querySelector('.tkc-facet__n'), opts: Array.prototype.map.call(det.querySelectorAll('input[data-facet-input]'), function (inp) { return { inp: inp, lab: inp.parentNode, c: inp.parentNode.querySelector('.tkc-opt__c') }; }) };
    });
  }
  function renderFacets() {
    if (!facetEls) buildFacets();
    FACET_KEYS.forEach(function (k) {
      var f = facetEls[k], sel = state[k], counts = countBy(k);
      f.n.hidden = sel.length === 0; f.n.textContent = sel.length || '';
      f.opts.forEach(function (o) {
        var v = o.inp.value, c = counts[v] || 0, on = sel.indexOf(v) >= 0, zero = c === 0 && !on;
        if (o.inp.checked !== on) o.inp.checked = on;
        if (o.inp.disabled !== zero) o.inp.disabled = zero;
        o.lab.classList.toggle('is-on', on); o.lab.classList.toggle('is-zero', zero);
        var cs = String(c); if (o.c.textContent !== cs) o.c.textContent = cs;
      });
      if (sel.length && !f.det.open && !facetOpen.hasOwnProperty(k)) f.det.open = true;
    });
  }
  function renderUse() {
    var c = countBy('use'); var all = DATA.filter(function (it) { return match(it, 'use'); }).length;
    $('.tkc-use').innerHTML = '<button type="button" class="tkc-use__btn" data-use="" aria-pressed="' + (state.use === '') + '">すべて<span>' + all + '</span></button>' +
      USES.map(function (u) { return '<button type="button" class="tkc-use__btn" data-use="' + esc(u.id) + '" aria-pressed="' + (state.use === u.id) + '">' + esc(u.label) + '<span>' + (c[u.id] || 0) + '</span></button>'; }).join('');
  }
  function activeList() {
    var a = [];
    if (state.q) a.push({ k: 'q', v: state.q, t: '「' + state.q + '」' });
    if (state.use) a.push({ k: 'use', v: state.use, t: useLabel(state.use) });
    ['volt', 'sock', 'genre', 'brand'].forEach(function (k) { state[k].forEach(function (v) { a.push({ k: k, v: v, t: k === 'sock' ? sockShort(v) : v }); }); });
    return a;
  }
  function stateWithout(k, v) {
    var s = JSON.parse(JSON.stringify(state));
    if (k === 'q') s.q = ''; else if (k === 'use') s.use = ''; else s[k] = s[k].filter(function (x) { return x !== v; });
    return s;
  }
  function removeFilter(k, v) { var s = stateWithout(k, v); state.q = s.q; state.use = s.use; ['brand', 'genre', 'volt', 'sock'].forEach(function (x) { state[x] = s[x]; }); if (k === 'q') $('.tkc-search__input').value = ''; }
  function resetAll() { state.q = ''; state.use = ''; state.brand = []; state.genre = []; state.volt = []; state.sock = []; $('.tkc-search__input').value = ''; }
  function emptyHTML() {
    var act = activeList();
    var opts = act.map(function (a) { return { a: a, n: results(stateWithout(a.k, a.v)).length }; }).filter(function (x) { return x.n > 0 && !(act.length === 1 && x.n === TOTAL); }).sort(function (x, y) { return y.n - x.n; });
    var near = [];
    if (state.q) {
      var t = tokens(state.q);
      near = DATA.filter(function (it) { return t.some(function (tk) { return tokenMatch(it, tk); }); });
      if (state.use) near = near.filter(function (it) { return it.use.indexOf(state.use) >= 0; }).concat(near.filter(function (it) { return it.use.indexOf(state.use) < 0; }));
    } else {
      var s = JSON.parse(JSON.stringify(state)); s.sock = []; s.genre = []; s.brand = [];
      near = results(s);
    }
    near = near.slice(0, 4);
    return '<div class="tkc-empty__box"><p class="tkc-empty__title">この条件に合う商品は見つかりませんでした</p>' +
      '<p class="tkc-empty__text">条件を1つ外すと、次の商品が見つかります。</p>' +
      '<div class="tkc-empty__actions">' + opts.slice(0, 4).map(function (x) {
        return '<button type="button" class="tkc-btn" data-rm="' + esc(x.a.k) + '" data-v="' + esc(x.a.v) + '">' + esc(x.a.t) + ' を外す（' + x.n + '件）</button>';
      }).join('') + '<button type="button" class="tkc-btn tkc-btn--primary" data-reset="1">すべての商品を見る（' + TOTAL + '件）</button></div>' +
      '<p class="tkc-empty__tip">よく探される条件</p><div class="tkc-empty__quick">' + QUICK.map(function (w) { return '<button type="button" class="tkc-chip" data-q="' + esc(w) + '">' + esc(w) + '</button>'; }).join('') + '</div></div>' +
      (near.length ? '<p class="tkc-empty__near">近い商品</p><ul class="tkc-grid tkc-grid--near">' + near.map(cardHTML).join('') + '</ul>' : '');
  }
  var lastSig = null, trackT, emptySig = ['', '', '', '', '', ''].join('/');
  function render() {
    var t0 = (window.performance && performance.now) ? performance.now() : 0;
    var res = sorted(results());
    $('.tkc-count').innerHTML = '<b>' + res.length + '</b>件' + (res.length !== TOTAL ? '<span class="tkc-count__all">／全' + TOTAL + '件</span>' : '');
    $('.tkc-sheet__apply').textContent = res.length + '件を表示';
    renderGrid(res);
    var empty = $('.tkc-empty'); empty.hidden = res.length > 0; empty.innerHTML = res.length ? '' : emptyHTML();
    var act = activeList();
    $('.tkc-active').innerHTML = act.map(function (a) {
      return '<li><button type="button" class="tkc-pill" data-rm="' + esc(a.k) + '" data-v="' + esc(a.v) + '" aria-label="' + esc(LABEL[a.k] + ' ' + a.t) + 'を外す">' + esc(a.t) + '<i aria-hidden="true">×</i></button></li>';
    }).join('') + (act.length ? '<li><button type="button" class="tkc-pill tkc-pill--reset" data-reset="1">すべて解除</button></li>' : '');
    $('.tkc-active').hidden = act.length === 0;
    var nf = state.brand.length + state.genre.length + state.volt.length + state.sock.length;
    var badge = $('.tkc-filterbtn__n'); badge.hidden = nf === 0; badge.textContent = nf;
    $('.tkc-search__clear').hidden = !state.q;
    $('.tkc-sort').value = state.sort;
    root.setAttribute('data-count', res.length);
    renderUse(); renderFacets(); renderCmpBar(); writeState();
    // 条件が変わって1.2秒止まったら、結果の件数を1回だけ送る（入力の途中は送らない）
    var sig = filterSig();
    if (sig !== lastSig) {
      clearTimeout(trackT);
      trackT = setTimeout(function () {
        if (sig === lastSig) return;
        lastSig = sig; if (sig === emptySig) return;
        var p = { q: state.q, use: USE_KEY[state.use] || '', brand: state.brand.join(','), genre: state.genre.join(','), volt: state.volt.join(','), sock: state.sock.join(','), count: res.length };
        track(res.length ? 'tkc_results' : 'tkc_zero_results', p);
      }, 1200);
    }
    if (t0) root.setAttribute('data-render-ms', (performance.now() - t0).toFixed(1));
  }

  /* ---------- 比較（最大3商品。スマホは項目ごとに縦に並べ、横スクロールなし） ---------- */
  function renderCmpBar() {
    var n = state.cmp.length;
    var bar = $('.tkc-cmpbar'); bar.hidden = n === 0; root.classList.toggle('has-cmp', n > 0);
    $('.tkc-cmpbar__list').innerHTML = state.cmp.map(function (h) {
      var it = BYH[h];
      return '<li><button type="button" class="tkc-cmpbar__item" data-cmp="' + esc(h) + '" aria-label="' + esc(it.modelDisp || it.name) + 'を比較から外す">' + esc(it.modelDisp || it.h) + '<i aria-hidden="true">×</i></button></li>';
    }).join('');
    var go = $('.tkc-cmpbar__go'); go.disabled = n < 2; go.textContent = n < 2 ? 'あと' + (2 - n) + '商品で比較できます' : n + '商品を比較する';
  }
  function cmpRows(list) {
    var dash = '<span class="tkc-na">—</span>';
    var rows = [];
    function row(label, vals, key) { rows.push({ label: label, vals: vals, key: key, diff: uniq(vals.map(function (v) { return v.replace(/<[^>]+>/g, ''); })).length > 1 }); }
    row('型番', list.map(function (it) { return '<span class="tkc-mono">' + esc(it.modelDisp || '—') + '</span>'; }));
    row('電圧', list.map(function (it) { return it.vtext ? esc(it.vtext) : dash; }), true);
    row('口金・規格', list.map(function (it) { return it.sockGroups.length ? esc(it.sockGroups.join('／')) : dash; }), true);
    row('極性', list.map(function (it) { return it.pol ? esc(it.pol) : dash; }));
    row('用途', list.map(function (it) { return it.use.length ? esc(it.use.map(useLabel).join('・')) : dash; }));
    row('ブランド', list.map(function (it) { return esc(it.brands.join(' / ')); }));
    row('価格', list.map(function (it) { return '<b>' + yen(it.p0) + '</b>円' + (it.p1 > it.p0 ? '〜' : ''); }));
    row('保証', list.map(function (it) { return it.warranty ? esc(it.warranty) : dash; }));
    var keys = []; list.forEach(function (it) { it.specKey.forEach(function (kv) { if (keys.indexOf(kv[0]) < 0) keys.push(kv[0]); }); });
    keys.slice(0, 6).forEach(function (k) {
      row(k, list.map(function (it) { var kv = it.specKey.filter(function (x) { return x[0] === k; })[0]; return kv ? esc(kv[1]) : dash; }));
    });
    row('ポイント', list.map(function (it) { return it.points.length ? '<ul class="tkc-cmp__pts">' + it.points.map(function (p) { return '<li>' + esc(p) + '</li>'; }).join('') + '</ul>' : dash; }));
    row('在庫', list.map(function (it) { return it.avail ? 'あり' : '<span class="tkc-out">在庫なし</span>'; }));
    return rows;
  }
  var diffOnly = false;
  function renderCmp() {
    var list = state.cmp.map(function (h) { return BYH[h]; }).filter(Boolean);
    var n = list.length;
    var head = '<div class="tkc-cmp__heads" style="--n:' + n + '"><div class="tkc-cmp__corner" aria-hidden="true"></div>' + list.map(function (it) {
      return '<div class="tkc-cmp__head"><a class="tkc-cmp__img" href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true"><span class="tkc-card__ph">' + esc(it.modelDisp) + '</span>' + imgTag(it, 240) + '</a>' +
        '<a class="tkc-cmp__name" href="' + esc(it.url) + '">' + esc(it.name) + '</a>' +
        '<button type="button" class="tkc-cmp__rm" data-cmp="' + esc(it.h) + '" aria-label="' + esc(it.modelDisp || it.name) + 'を比較から外す">外す</button></div>';
    }).join('') + '</div>';
    var rows = cmpRows(list).filter(function (r) { return !diffOnly || r.diff || r.key; });
    var body = rows.map(function (r) {
      return '<div class="tkc-cmp__row' + (r.key ? ' is-key' : '') + (r.diff ? ' is-diff' : '') + '" style="--n:' + n + '"><div class="tkc-cmp__label">' + esc(r.label) + (r.diff ? '<span class="tkc-cmp__dmark">違い</span>' : '') + '</div>' +
        r.vals.map(function (v) { return '<div class="tkc-cmp__val">' + v + '</div>'; }).join('') + '</div>';
    }).join('');
    var foot = '<div class="tkc-cmp__row tkc-cmp__row--go" style="--n:' + n + '"><div class="tkc-cmp__label"><span class="tkc-vh">商品ページ</span></div>' + list.map(function (it) {
      return '<div class="tkc-cmp__val"><a class="tkc-btn tkc-btn--primary tkc-btn--block" href="' + esc(it.url) + '">商品を見る</a></div>';
    }).join('') + '</div>';
    $('.tkc-cmp__body').innerHTML = head + body + foot;
    $('.tkc-cmp__count').textContent = n + '商品';
  }
  var lastFocus = null;
  function syncLock() { document.documentElement.classList.toggle('tkc-lock', root.classList.contains('is-cmp-open') || root.classList.contains('is-sheet-open')); }
  function openCmp(open) {
    var dlg = $('.tkc-cmp');
    if (open) { var tt = $('.tkc-toast'); if (tt) { tt.hidden = true; clearTimeout(toastT); } track('tkc_compare_open', { count: state.cmp.length, handles: state.cmp.join(',') }); lastFocus = document.activeElement; renderCmp(); dlg.hidden = false; root.classList.add('is-cmp-open'); syncLock(); $('.tkc-cmp__close').focus(); }
    else { dlg.hidden = true; root.classList.remove('is-cmp-open'); syncLock(); if (lastFocus && lastFocus.focus) lastFocus.focus(); }
  }
  var toastT;
  function toast(msg) { var t = $('.tkc-toast'); t.textContent = msg; t.hidden = false; clearTimeout(toastT); toastT = setTimeout(function () { t.hidden = true; }, 2600); }
  function toggleCmp(h) {
    var i = state.cmp.indexOf(h);
    if (i >= 0) state.cmp.splice(i, 1);
    else { if (state.cmp.length >= CMP_MAX) { toast('比較できるのは3商品までです。1つ外してから追加してください。'); track('tkc_compare_full', { handle: h }); return; } state.cmp.push(h); }
    track(i >= 0 ? 'tkc_compare_remove' : 'tkc_compare_add', { handle: h, count: state.cmp.length });
    render();
    if (!$('.tkc-cmp').hidden) { if (state.cmp.length < 1) openCmp(false); else renderCmp(); }
  }

  /* ---------- 絞り込みシート（スマホ・タブレット） ---------- */
  function openSheet(open) {
    var sh = $('.tkc-sheet');
    sh.classList.toggle('is-open', open); root.classList.toggle('is-sheet-open', open); syncLock();
    if (open && !isWide) { sh.setAttribute('role', 'dialog'); sh.setAttribute('aria-modal', 'true'); } else { sh.setAttribute('role', 'region'); sh.removeAttribute('aria-modal'); }
    $('.tkc-filterbtn').setAttribute('aria-expanded', String(open));
    if (open) { lastFocus = document.activeElement; $('.tkc-sheet__close').focus(); } else if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------- 操作 ---------- */
  var typeT;
  $('.tkc-search__input').addEventListener('input', function (e) { clearTimeout(typeT); var v = e.target.value; typeT = setTimeout(function () { state.q = v.trim(); render(); }, 150); });
  $('.tkc-search').addEventListener('submit', function (e) { e.preventDefault(); clearTimeout(typeT); state.q = $('.tkc-search__input').value.trim(); render(); $('.tkc-search__input').blur(); });
  $('.tkc-search__clear').addEventListener('click', function () { state.q = ''; $('.tkc-search__input').value = ''; render(); $('.tkc-search__input').focus(); });
  $('.tkc-sort').addEventListener('change', function (e) { state.sort = e.target.value; render(); track('tkc_sort', { sort: state.sort }); });
  root.addEventListener('change', function (e) {
    var i = e.target; var k = i.getAttribute('data-facet-input'); if (!k) return;
    if (i.checked) { if (state[k].indexOf(i.value) < 0) state[k].push(i.value); } else state[k] = state[k].filter(function (x) { return x !== i.value; });
    render();
  });
  root.addEventListener('toggle', function (e) { var d = e.target; if (d.classList && d.classList.contains('tkc-facet')) facetOpen[d.getAttribute('data-facet')] = d.open; }, true);
  root.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : e.target.parentNode;
    var b;
    var lk = t.closest('a[href]');
    if (lk) {
      var card = lk.closest('.tkc-card'), inCmpView = lk.closest('.tkc-cmp');
      if (card || inCmpView) {
        var hh = card ? card.getAttribute('data-h') : (URLH[lk.getAttribute('href')] || '');
        var pos = card && card.parentNode ? Array.prototype.indexOf.call(card.parentNode.children, card) + 1 : 0;
        track('tkc_product_click', { handle: hh, from: inCmpView ? 'compare' : (card.parentNode && card.parentNode.classList.contains('tkc-grid--near') ? 'zero_near' : 'card'), position: pos });
      }
    }
    if ((b = t.closest('[data-cmp]'))) { e.preventDefault(); toggleCmp(b.getAttribute('data-cmp')); return; }
    if ((b = t.closest('[data-refine]'))) {
      var k = b.getAttribute('data-refine'), v = b.getAttribute('data-v');
      if (!$('.tkc-cmp').hidden) openCmp(false);
      if (k === 'use') state.use = v; else if (state[k].indexOf(v) < 0) state[k].push(v);
      render(); toast((k === 'sock' ? sockShort(v) : k === 'use' ? useLabel(v) : v) + ' で絞り込みました（' + results().length + '件）');
      track('tkc_refine', { key: k, value: v });
      var top = $('.tkc-bar'); if (top && top.scrollIntoView) top.scrollIntoView({ block: 'start' });
      return;
    }
    if ((b = t.closest('[data-rm]'))) { removeFilter(b.getAttribute('data-rm'), b.getAttribute('data-v')); render(); return; }
    if ((b = t.closest('[data-reset]'))) { resetAll(); render(); return; }
    if ((b = t.closest('[data-q]'))) { track('tkc_quick', { word: b.getAttribute('data-q') }); resetAll(); state.q = b.getAttribute('data-q'); $('.tkc-search__input').value = state.q; render(); return; }
    if ((b = t.closest('[data-use]'))) { state.use = b.getAttribute('data-use'); render(); return; }
    if (t.closest('.tkc-filterbtn')) { openSheet(true); return; }
    if (t.closest('.tkc-sheet__close') || t.closest('.tkc-sheet__apply')) { openSheet(false); return; }
    if (t.closest('.tkc-sheet__reset')) { state.brand = []; state.genre = []; state.volt = []; state.sock = []; render(); return; }
    if (t.closest('.tkc-cmpbar__go')) { openCmp(true); return; }
    if (t.closest('.tkc-cmpbar__clear')) { state.cmp = []; render(); return; }
    if (t.closest('.tkc-cmp__close')) { openCmp(false); return; }
    if (t.closest('.tkc-scrim')) { if (!$('.tkc-cmp').hidden) openCmp(false); else openSheet(false); return; }
    if (t.closest('.tkc-copy')) {
      track('tkc_compare_copy', { count: state.cmp.length });
      var url = location.href;
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(function () { toast('このページのURLをコピーしました'); }, function () { toast(url); });
      else toast(url);
    }
  });
  root.addEventListener('change', function (e) { if (e.target.classList.contains('tkc-cmp__diffonly')) { diffOnly = e.target.checked; renderCmp(); } });
  /* 比較・絞り込みシート（スマホ）を開いている間は、Tabキーのフォーカスを中に留める */
  function trapBox() {
    if (!$('.tkc-cmp').hidden) return $('.tkc-cmp');
    if (!isWide && $('.tkc-sheet').classList.contains('is-open')) return $('.tkc-sheet');
    return null;
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Tab') {
      var box = trapBox(); if (!box) return;
      var f = Array.prototype.filter.call(box.querySelectorAll('a[href]:not([tabindex="-1"]),button:not([disabled]),input:not([disabled]),select,summary'), function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      var a = document.activeElement, first = f[0], last = f[f.length - 1];
      if (e.shiftKey ? (a === first || !box.contains(a)) : (a === last || !box.contains(a))) { e.preventDefault(); (e.shiftKey ? last : first).focus(); }
      return;
    }
    if (e.key !== 'Escape') return;
    if (!$('.tkc-cmp').hidden) openCmp(false); else if ($('.tkc-sheet').classList.contains('is-open')) openSheet(false);
  });
  window.addEventListener('hashchange', function () { readState(); render(); });
  var mqWide = window.matchMedia('(min-width: 1024px)');
  var onWide = function () { if (mqWide.matches !== isWide) { isWide = mqWide.matches; facetOpen = {}; facetEls = null; renderFacets(); if (isWide && $('.tkc-sheet').classList.contains('is-open')) openSheet(false); } };
  if (mqWide.addEventListener) mqWide.addEventListener('change', onWide); else if (mqWide.addListener) mqWide.addListener(onWide);

  /* テーマのヘッダーがページの上に重なる作り（position:absolute）のとき、見出し・検索欄が隠れないよう、重なる分だけ上に余白を足す */
  var hdrSel = root.getAttribute('data-header-selector') || '';
  function fitHeader() {
    var h = hdrSel ? document.querySelector(hdrSel) : null, off = 0;
    if (h) {
      var pos = getComputedStyle(h).position;
      if (pos === 'absolute' || pos === 'fixed') off = Math.max(0, Math.round(h.getBoundingClientRect().bottom - root.getBoundingClientRect().top));
    }
    root.style.setProperty('--tkc-head-offset', off + 'px');
  }
  if (hdrSel) {
    fitHeader();
    var fitT; window.addEventListener('resize', function () { clearTimeout(fitT); fitT = setTimeout(fitHeader, 120); });
    if (window.ResizeObserver && document.querySelector(hdrSel)) new ResizeObserver(fitHeader).observe(document.querySelector(hdrSel));
    window.addEventListener('load', fitHeader);
  }

  var entryHash = !!location.hash.replace(/^#/, '');
  readState(); render();
  lastSig = filterSig();  // 開いた直後の状態は「結果」として送らない（下の tkc_view で送る）
  track('tkc_view', { from_link: entryHash ? 1 : 0, count: +root.getAttribute('data-count') || 0, sock: state.sock.join(','), genre: state.genre.join(','), cmp: state.cmp.length });
  root.classList.add('is-ready');
})();
